import React from 'react';
import { Instagram } from 'lucide-react';
export function InstagramBanner() {
  return <section className="py-24 bg-[#FDF8F3] relative" data-id="element-261">
      {/* African pattern overlay */}
      <div className="absolute inset-0 african-pattern opacity-15" data-id="element-262" />

      <div className="relative max-w-2xl mx-auto text-center px-4" data-id="element-263">
        <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-[#D4A853]/10 flex items-center justify-center border border-[#D4A853]/30" data-id="element-264">
          <Instagram className="w-7 h-7 text-[#D4A853]" strokeWidth={1.5} data-id="element-265" />
        </div>
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-['Playfair_Display'] text-[#5C3D2E] mb-5" data-id="element-266">
          Join the Sisterhood
        </h2>
        <p className="text-[#6B5B4F] mb-8 font-['Raleway'] text-xl sm:text-3xl leading-relaxed" data-id="element-267">
          Follow @christiana.nnanna for daily style inspiration,
          behind-the-scenes moments, and exclusive offers for our community of
          queens.
        </p>
        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-base uppercase tracking-[0.15em] text-[#5C3D2E] font-medium border-b-2 border-[#D4A853] pb-1 hover:text-[#D4A853] transition-colors" data-id="element-268">
          <span className="w-4 h-px bg-[#D4A853]" data-id="element-269" />
          Visit Instagram
          <span className="w-4 h-px bg-[#D4A853]" data-id="element-270" />
        </a>
      </div>
    </section>;
}